module.exports = __webpack_public_path__ + "img/bg-symptom4.d78054e2.png";